export const quotesArr = [
  {
    quote: 'The best ideas come as jokes. Make your thinking as funny as possible.',
    author: 'David Ogilvy'
  },
  {
    quote: 'If you’re not prepared to be wrong, you’ll never come up with anything original.',
    author: 'Sir Ken Robinson'
  },
  {
    quote: 'Design creates culture. Culture shapes values. Values determine the future',
    author: 'Robert L. Peters'
  },
  {
    quote: 'We are what we repeatedly do. Excellence, then, is not an act, but a habit.',
    author: 'Aristotle'
  },
  {
    quote: 'Do good work for good people.',
    author: 'Aaron Draplin'
  },
  {
    quote: 'The soul never thinks without an image.',
    author: 'Aristotle'
  },
  {
    quote: 'Content precedes design. Design in the absence of content is not design, it’s decoration.',
    author: 'Jeffrey Zeldman'
  },
  {
    quote: 'When you believe a thing, believe it all the way, implicitly and unquestionably.',
    author: 'Walt Disney'
  },
  {
    quote: 'Good design is obvious. Great design is transparent.',
    author: 'Joe Sparano'
  },
  {
    quote: 'Design and art are independent coordinates that provide their greatest satisfactions when experienced simultaneously.',
    author: 'Milton Glaser'
  },
  {
    quote: "Y'all talk about UX like it’s just another feature. For a user, it literally is the product. Full stop. Everything else is inside baseball.",
    author: 'Startup L. Jackson Twitter'
  },
  {
    quote: 'The most profound technologies are those that disappear. They weave themselves into the fabric of everyday life until they are indistinguishable from it.',
    author: 'Mark Weiser'
  },
  {
    quote: 'Design is an opportunity to continue telling the story, not just to sum everything up.',
    author: 'Tate Linden'
  },
  {
    quote: 'Less is more work.',
    author: 'Patric McCue'
  },
  {
    quote: 'Curiosity about life in all its aspects, I think, is still the secret of great creative people.',
    author: 'Leo Burnett'
  },
  {
    quote: 'As we decrease uncertainty, we give ourselves permission to increase fidelity.',
    author: 'Jonathan Irwin'
  },
  {
    quote: 'The work you do while you procrastinate is probably the work you should be doing for the rest of your life.',
    author: 'Jessica Hische'
  },
  {
    quote: 'Put hot triggers in the path of motivated people.',
    author: 'B.J. Fogg'
  },
  {
    quote: 'Design isn’t crafting a beautiful textured button with breathtaking animation. It’s figuring out if there’s a way to get rid of the button altogether.',
    author: 'Edward Tufte'
  },
  {
    quote: 'A user interface is like a joke. If you have to explain it, it’s not that good.',
    author: 'Martin LeBlanc'
  },
  {
    quote: 'A designer is an emerging synthesis of artist, inventor, mechanic, objective economist, and evolutionary strategist.',
    author: 'Buckminster Fuller'
  },
  {
    quote: 'Artists can have greater access to reality; they can see patterns and details and connections that other people, distracted by the blur of life, might miss.',
    author: 'Jay-Z'
  },
  {
    quote: 'Any product that needs a manual to work is broken.',
    author: 'Elon Musk'
  },
  {
    quote: 'Good designers must always be avant-gardists, always one step ahead of the times. They should–and must–question everything generally thought to be obvious.',
    author: 'Dieter Rams'
  },
  {
    quote: 'Any intelligent fool can make things bigger and more complex. It takes a touch of genius—and a lot of courage—to move in the opposite direction.',
    author: 'E. F. Schumacher'
  },
  {
    quote: 'Design is so simple. That’s why it’s so complicated.',
    author: 'Paul Rand'
  },
  {
    quote: 'Get in over your head as often and as joyfully as possible.',
    author: 'Alexander Isley'
  },
  {
    quote: 'Everything should be made as simple as possible, but not simpler.',
    author: 'Albert Einstein'
  },
  {
    quote: 'Great design is a multi-layered relationship between human life and its environment.',
    author: 'Naoto Fukasawa'
  },
  {
    quote: 'Only those who attempt the absurd will achieve the impossible.',
    author: 'M.C. Escher'
  },
  {
    quote: 'Sometimes when you innovate, you make mistakes. It is best to admit them quickly, and get on with improving your other innovations.',
    author: 'Steve Jobs'
  },
  {
    quote: 'The most beautiful thing we can experience is the mysterious. It is the source of all true art and science.',
    author: 'Albert Einstein'
  },
  {
    quote: 'The most beautiful things in the world cannot be seen or even touched, they must be felt with the heart.',
    author: 'Helen Keller'
  },
  {
    quote: 'Those who danced were thought to be quite insane by those who could not hear the music.',
    author: 'Angela Monet'
  },
  {
    quote: 'We must be willing to let go of the life we have planned, so as to have the life that is waiting for us.',
    author: 'E.M. Forster'
  },
  {
    quote: "It always seems impossible until it's done.",
    author: 'Nelson Mandela'
  },
  {
    quote: 'How lucky I am to have something that makes saying goodbye so hard.',
    author: 'A.A. Milne'
  },
  {
    quote: "Courage doesn't always roar. Sometimes courage is a quiet voice at the end of the day saying, 'I will try again tomorrow.'",
    author: 'Mary Anne Radmacher'
  },
  {
    quote: 'The difference between the almost-right word and the right word is the difference between the lightning bug and the lightning!',
    author: 'Mark Twain'
  },
  {
    quote: 'There are five virtues: accuracy, literacy, a strong hand, industriousness, and the perfect writing utensils.',
    author: 'Mir-Ali Khoravi'
  },
  {
    quote: 'Typography is what language looks like.',
    author: 'Ellen Lupton'
  },
  {
    quote: 'Language is not so much a creator or shaper of human nature, so much as a window onto human nature.',
    author: 'Steven Pinker'
  },
  {
    quote: 'I saw the angel in the marble and carved until I set him free.',
    author: 'Michelangelo Buonarroti'
  },
  {
    quote: 'Typography needs to be audible. Typography needs to be felt. Typography needs to be experiences.',
    author: 'Helmut Schmid'
  }
];



// WEBPACK FOOTER //
// ./src/components/generator/constants/QuotesText.js